import { Post } from "./ApiBase";

export async function ContinueConversation(conversation) {
  return await Post("/api/GuidedRant/Continue", { conversation });
}

export async function ExtractAchievements(conversation) {
  return await Post("/api/GuidedRant/Extract", { conversation });
}

export async function StarStep(
  step,
  userInput,
  accomplishment,
  previousSteps,
  conversationContext,
) {
  return await Post("/api/GuidedRant/StarStep", {
    step: step,
    userInput: userInput,
    accomplishment: accomplishment,
    previousSteps: previousSteps || {},
    conversationContext: conversationContext || null,
  });
}

export async function SageReviewWins(conversation, wins, profileSummary) {
  return await Post("/api/Sage/ReviewWins", {
    conversation,
    wins,
    profileSummary: profileSummary || "",
  });
}

export async function SageProfileAdvisor(conversation, profileSummary, mode) {
  return await Post("/api/Sage/ProfileAdvisor", {
    conversation,
    profileSummary: profileSummary || "",
    mode: mode || "roles",
  });
}

export async function SageStarGapFill(
  conversation,
  achievementText,
  background,
  responsibility,
  actionResult,
  measurement,
  profileSummary,
) {
  return await Post("/api/Sage/StarGapFill", {
    conversation,
    achievementText: achievementText || "",
    background: background || "",
    responsibility: responsibility || "",
    actionResult: actionResult || "",
    measurement: measurement || "",
    profileSummary: profileSummary || "",
  });
}

export async function SageCareerCoach(
  conversation,
  profileContext,
  isOpeningMessage,
) {
  return await Post("/api/Sage/CareerCoach", {
    conversation: conversation || [],
    profileContext: profileContext || "",
    isOpeningMessage: isOpeningMessage || false,
  });
}

export async function SagePeriodSummary(
  wins,
  startDate,
  endDate,
  options,
  profileContext,
) {
  return await Post("/api/Sage/PeriodSummary", {
    wins,
    startDate,
    endDate,
    format: options ? options.format : undefined,
    purpose: options ? options.purpose : undefined,
    tone: options ? options.tone : undefined,
    length: options ? options.length : undefined,
    profileContext: profileContext || undefined,
  });
}
